import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02026e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-message-box" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "21"
}
const _hoisted_4 = ["fill"]
const _hoisted_5 = { class: "chat-message-box__message" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#afb7bd",
    d: "M20.223 1.96a6.53 6.53 0 0 0-9.219 0l-9.021 9.013a5.09 5.09 0 0 0 0 7.207 5.11 5.11 0 0 0 7.213 0l9.022-9.014a3.682 3.682 0 0 0 0-5.204 3.691 3.691 0 0 0-5.209 0L5.315 11.65a.847.847 0 1 0 1.199 1.198l7.694-7.688a1.992 1.992 0 0 1 2.811 0 1.988 1.988 0 0 1 0 2.809l-9.022 9.013a3.41 3.41 0 0 1-4.815 0 3.397 3.397 0 0 1 0-4.811l9.021-9.014a4.824 4.824 0 0 1 6.821 0 4.815 4.815 0 0 1 0 6.815l-4.01 4.006a.847.847 0 1 0 1.199 1.198l4.01-4.006a6.517 6.517 0 0 0 0-9.21z"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.percentage !== null)
      ? (_openBlock(), _createBlock(_component_progress_bar, {
          key: 0,
          class: "mb-3",
          percentage: _ctx.percentage
        }, null, 8, ["percentage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
        class: _normalizeClass([
        'chat-message-box__button',
        _ctx.active && 'chat-message-box__button--active',
      ]),
        disabled: !_ctx.active
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            fill: [_ctx.active ? '#FFF' : '#afb7bd'],
            d: "M22.642 8.61 3.657.191C2.858.14 1.954.5 1.299.571.645 1.138.371 2.1.585 2.848l1.69 6.621h8.273a.689.689 0 1 1 0 1.377H2.275l-1.69 6.62c-.214.839.06 1.711.714 2.278.656.567 1.56.711 2.358.38l18.986-7.87c.864-.358 1.797-.334 1.797-2.097 0-.935-.933-1.738-1.798-1.547z"
          }, null, 8, _hoisted_4)
        ]))
      ], 10, _hoisted_2),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("textarea", {
          rows: "1",
          class: "chat-message-box__textarea",
          placeholder: "پیامی بنویسید ...",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput($event.target))),
          "aria-placeholder": "پیامی بنویسید ..."
        }, null, 544), [
          [_vModelText, _ctx.message]
        ]),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fileInputRef && _ctx.fileInputRef.click())),
          class: "chat-message-box__attach"
        }, _hoisted_7),
        _createElementVNode("input", {
          ref: "fileInputRef",
          type: "file",
          class: "chat-message-box__file-input",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args))),
          accept: ".jpeg,.jpg,.png,.pdf"
        }, null, 544)
      ])
    ])
  ], 64))
}